// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MenuItem_Wrapper__2TDpq","Link":"MenuItem_Link__xeOb4","MenuItem":"MenuItem_MenuItem__fJwRO","selected":"MenuItem_selected__YdqyG"};